/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetRegionDeliveryRangeSettingAdminResponse } from '../models/GetRegionDeliveryRangeSettingAdminResponse';
import type { PostPutRegionDeliveryRangeSettingRequestAdmin } from '../models/PostPutRegionDeliveryRangeSettingRequestAdmin';
import type { RegionDeliveryRangeSettingAdminDto } from '../models/RegionDeliveryRangeSettingAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionDeliveryRangeSettingsService {
    /**
     * **Required Policy:** `ViewRegionDeliveryRangeSettings`
     * @returns RegionDeliveryRangeSettingAdminDto OK
     * @throws ApiError
     */
    public static getRegionDeliveryRangeSettingByRegionIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<RegionDeliveryRangeSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regiondeliveryrangesettings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRegionDeliveryRangeSettings`
     * @returns RegionDeliveryRangeSettingAdminDto OK
     * @throws ApiError
     */
    public static putRegionDeliveryRangeSettingAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutRegionDeliveryRangeSettingRequestAdmin,
    }): CancelablePromise<RegionDeliveryRangeSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/regiondeliveryrangesettings/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewRegionDeliveryRangeSettings`
     * @returns GetRegionDeliveryRangeSettingAdminResponse OK
     * @throws ApiError
     */
    public static getRegionDeliveryRangeSettingsAdmin(): CancelablePromise<GetRegionDeliveryRangeSettingAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regiondeliveryrangesettings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRegionDeliveryRangeSettings`
     * @returns RegionDeliveryRangeSettingAdminDto OK
     * @throws ApiError
     */
    public static postRegionDeliveryRangeSettingAdmin({
        requestBody,
    }: {
        requestBody?: PostPutRegionDeliveryRangeSettingRequestAdmin,
    }): CancelablePromise<RegionDeliveryRangeSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/regiondeliveryrangesettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
